import axios from 'axios';
import './Banner.scss';
import React, { useState, useEffect, useRef } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { toast } from 'react-toastify';
import Environment from 'utils/environment';

const Bannerappmanagment = () => {
    const BAS_URL =  Environment.base_url2
    const [image, setImage] = useState("");
    const [baseImage, setBaseImage] = useState("");
    const [accountImage, setAccountImage] = useState();
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [bannerData, setBannerData] = useState([]);
    const [newBannerLink, setNewBannerLink] = useState('');
    const [newImageFile, setNewImageFile] = useState(null);
    const [newBaseImage, setNewBaseImage] = useState(null);
    const handleShow = () => setShow(true);
    const handleShow1 = () => setShow1(true);
    const editFileInputRef = useRef(null);
    const val = localStorage.getItem("accessToken");
     const handleClose = () => {
        setShow(false);
        resetForm();
    };

    const handleClose1 = () => {
        setShow1(false);
        resetForm();
    };
  
    const uploadImages = async (e) => {
        const file = e.target.files[0];
        const base64 = await convertBase645(file);
        setBaseImage(base64);
        setImage(file);
    };

    const convertBase645 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => resolve(fileReader.result);
            fileReader.onerror = (error) => reject(error);
        });
    };
   

    const resetForm = () => {
        setNewImageFile(null);
        setNewBaseImage(null);
        setNewBannerLink('');
        setEditingBanner(null);
    };


     



    const fetchBanners = async () => {
        try {
            const response = await axios.get(`${BAS_URL}/banners?limit=10&offset=1&filter=device=eq:mobile`, {
                headers: {
                    Authorization: "Bearer " + val,
                },
            });
            if (response.data.data && response.data.data.banners) {
                setBannerData(response.data.data.banners);
            }
        } catch (error) {
            console.error("Error fetching banners:", error);
        }
    };

    useEffect(() => {
        fetchBanners();
    }, []);

    const uploadNewBanner = async () => {
        const formData = new FormData();
        formData.append('bannerLink', newBannerLink);
        formData.append('type', 'main banner 1');
        formData.append('device', 'mobile');

        formData.append('bannerImage', newImageFile);

        try {
            const response = await axios.post(`${BAS_URL}/banners`, formData, {
                headers: {
                    Authorization: "Bearer " + val,
                },
            });
            toast.success('New banner uploaded successfully!');
            window.location.reload();
        } catch (error) {
            console.error('New Banner Upload Failed:', error);
            toast.error('New banner upload failed!');
            setNewBannerLink('');
            setNewImageFile(null);
            setNewBaseImage(null);
        }
    };
    const [editingBanner, setEditingBanner] = useState(null);

    const handleUpdateBanner = async () => {
        if (!editingBanner || !editingBanner.id) return;

        const formData = new FormData();
        formData.append('bannerLink', newBannerLink);
        formData.append('type', 'main banner 1');
         if (editingBanner.newImageFile) {
            formData.append('bannerImage', editingBanner.newImageFile);
        }
        formData.append('isPublish', 'true');
        try {
            await axios.patch(
                `${BAS_URL}/banners/${editingBanner.id}/is-publish`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${val}`,
                    },
                }
            );
            toast.success("Banner updated successfully!");
            window.location.reload();
        } catch (error) {
            console.error("Error updating banner:", error);
            toast.error("Failed to update banner.");
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setNewImageFile(file);
            setNewBaseImage(URL.createObjectURL(file));
            setEditingBanner((prev) => ({ ...prev, newImageFile: file }));
        }
    };


 // --- Banner Deletion (DELETE) ---
    const handleDeleteBanner = async (bannerId) => {
             try {
                await axios.delete(`${BAS_URL}/banners/${bannerId}`, {
                    headers: {
                        Authorization: "Bearer " + val,
                    },
                });
                toast.success("Banner deleted successfully!");
                window.location.reload(); 
            } catch (error) {
                console.error("Error deleting banner:", error);
                toast.error("Failed to delete banner.");
            }
     };
    return (
        <>
            <div className="headerbannnermangament">
                <h1 className="headerbannermain">App Banners</h1>
                <button onClick={handleShow} className='buttonaddmorebanner'>Add more</button>
            </div>

            <div className="imgselctbannermain">
                {bannerData.map((item, index) => (
                    <div className="firstlineimgselect" key={index}>
                        <div className="chlimgselect">
                            <p>Image</p>
                            <div className="item-upload">
                                <ul className="list-inline">
                                    <li className="list-inline-item">
                                        <label>
                                            <div className="uploaded-img-wrapper">
                                                <img src={item.imageUrl} alt="img" className="img-fluid upload-img" />

                                                <div className="img-icons">
                                                    <button
                                                        onClick={() => {
                                                            setEditingBanner(item);
                                                            setNewBannerLink(item.bannerLink); // Prefill
                                                            setNewBaseImage(item.imageUrl); // Show old image
                                                            handleShow1();
                                                        }}
                                                        // onClick={handleShow1} 
                                                        className="edit-icon" >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                            <path d="M20.817 22.5728H3.15498C2.75268 22.5728 2.41907 22.2391 2.41907 21.8368C2.41907 21.4345 2.75268 21.1009 3.15498 21.1009H20.817C21.2193 21.1009 21.5529 21.4345 21.5529 21.8368C21.5529 22.2391 21.2193 22.5728 20.817 22.5728Z" fill="#CACACA" />
                                                            <path d="M18.8742 4.40057C16.9706 2.497 15.1063 2.44794 13.1536 4.40057L11.9664 5.58785C11.8683 5.68597 11.829 5.84296 11.8683 5.98034C12.614 8.58057 14.6942 10.6608 17.2944 11.4065C17.3336 11.4163 17.3729 11.4261 17.4121 11.4261C17.5201 11.4261 17.6182 11.3869 17.6967 11.3084L18.8742 10.1211C19.8456 9.15949 20.3166 8.22733 20.3166 7.28536C20.3264 6.31395 19.8554 5.37198 18.8742 4.40057Z" fill="#CACACA" />
                                                            <path d="M15.5282 12.2994C15.2436 12.162 14.9689 12.0246 14.7039 11.8677C14.4881 11.7401 14.282 11.6027 14.076 11.4555C13.9092 11.3476 13.7129 11.1906 13.5265 11.0336C13.5069 11.0238 13.4382 10.9649 13.3597 10.8864C13.0359 10.6117 12.6728 10.2585 12.349 9.86596C12.3196 9.84634 12.2705 9.77765 12.2018 9.68934C12.1037 9.5716 11.9369 9.37535 11.7897 9.14967C11.672 9.00249 11.5346 8.78662 11.407 8.57075C11.25 8.30582 11.1127 8.04089 10.9753 7.76615C10.9645 7.74294 10.9538 7.7198 10.9434 7.69672C10.7821 7.34139 10.3174 7.23676 10.0415 7.51267L4.46981 13.0844C4.34226 13.2119 4.22451 13.4572 4.19507 13.624L3.66521 17.3821C3.56709 18.0493 3.75352 18.6773 4.16564 19.0992C4.51888 19.4427 5.00948 19.6291 5.53934 19.6291C5.65709 19.6291 5.77484 19.6193 5.89258 19.5997L9.66047 19.0698C9.83709 19.0404 10.0824 18.9226 10.2001 18.7951L15.7642 13.231C16.042 12.9532 15.9374 12.4757 15.5766 12.3203C15.5605 12.3134 15.5444 12.3064 15.5282 12.2994Z" fill="#CACACA" />
                                                        </svg>
                                                    </button>
                                                    <button className="delete-icon" onClick={() => handleDeleteBanner(item.id)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                            <path d="M21.1391 6.11769C19.5594 5.9607 17.9796 5.84295 16.39 5.75464V5.74483L16.1742 4.46924C16.027 3.56652 15.8111 2.21243 13.5151 2.21243H10.9443C8.65802 2.21243 8.44215 3.50764 8.28516 4.45943L8.0791 5.71539C7.16657 5.77426 6.25403 5.83314 5.3415 5.92145L3.33981 6.11769C2.92769 6.15694 2.63333 6.51999 2.67258 6.92229C2.71182 7.32459 3.06506 7.61896 3.47718 7.57971L5.47887 7.38347C10.6205 6.87323 15.8013 7.06947 21.0018 7.58952C21.0312 7.58952 21.0508 7.58952 21.0803 7.58952C21.4531 7.58952 21.7769 7.30497 21.8162 6.92229C21.8456 6.51999 21.5513 6.15694 21.1391 6.11769Z" fill="#E15151" />
                                                            <path d="M19.3337 8.97304C19.0982 8.72773 18.7744 8.59036 18.4408 8.59036H6.03813C5.70452 8.59036 5.3709 8.72773 5.14522 8.97304C4.91954 9.21834 4.79198 9.55196 4.81161 9.89539L5.41997 19.9627C5.5279 21.4542 5.66527 23.3185 9.08973 23.3185H15.3892C18.8136 23.3185 18.951 21.464 19.0589 19.9627L19.6673 9.9052C19.6869 9.55196 19.5594 9.21834 19.3337 8.97304ZM13.8683 18.4026H10.6008C10.1985 18.4026 9.8649 18.069 9.8649 17.6667C9.8649 17.2644 10.1985 16.9307 10.6008 16.9307H13.8683C14.2706 16.9307 14.6042 17.2644 14.6042 17.6667C14.6042 18.069 14.2706 18.4026 13.8683 18.4026ZM14.6925 14.4777H9.7864C9.3841 14.4777 9.05048 14.1441 9.05048 13.7418C9.05048 13.3395 9.3841 13.0059 9.7864 13.0059H14.6925C15.0948 13.0059 15.4284 13.3395 15.4284 13.7418C15.4284 14.1441 15.0948 14.4777 14.6925 14.4777Z" fill="#E15151" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>

                                            {/* ///// */}


                                        </label>
                                    </li>
                                </ul>
                            </div>
                            <input className='bannerimgselectimg' type="text" placeholder='URL' value={item.bannerLink || ''} readOnly />
                        </div>
                    </div>
                ))}
            </div>

            <Offcanvas show={show} onHide={handleClose} className="bannersitemanagmentoffcanvasssss">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>App Banner</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="bannerss">
                        <h4>Banner Image</h4>
                        {/* <h4>HAmmad</h4> */}
                        
                        <div className="item-upload">
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    <input id="upload-new" type="file" className="d-none" onChange={handleImageChange} />

                                    <label htmlFor="upload-new">
                                        {!newBaseImage ? (
                                            <div className="uploadimgprnt">
                                                <img src="/assestsss/gallery-add.svg" className="img-fluid" />
                                                <h4>Drag your image here</h4>
                                                <p>(Size 16:9)</p>
                                            </div>
                                        ) : (
                                            <div className="preview-container">
                                                <img src={newBaseImage} alt="Preview" className="img-preview" />
                                            </div>
                                        )}
                                    </label>
                                </li>
                            </ul>
                        </div>

                        <div className="filedinput">
                            <input type="text" placeholder="URL" value={newBannerLink} onChange={(e) => setNewBannerLink(e.target.value)} />
                        </div>

                        <div className="buttonss">
                            <button className="btn-1" onClick={handleClose}>Cancel</button>
                            <button className="btn-1 btn-2" onClick={uploadNewBanner}>Save</button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* //// */}
            <Offcanvas show={show1} onHide={handleClose1} className="bannersitemanagmentoffcanvasssss">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>App Banner</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="bannerss">
                        <h4>Banner Image</h4>
                    
                        <div className="item-upload">
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    <input id="upload-edit" type="file" className="d-none" onChange={handleImageChange} />
                                    <label htmlFor="upload-edit">
                                        {!newBaseImage ? (
                                            <div className="uploadimgprnt">
                                                <img src="/assestsss/gallery-add.svg" className="img-fluid" />
                                                <h4>Drag your image here</h4>
                                                <p>(Size 16:9)</p>
                                            </div>
                                        ) : (
                                            <div className="preview-container">
                                                <img src={newBaseImage} alt="Preview" className="img-preview" />
                                            </div>
                                        )}
                                    </label>
                                </li>
                            </ul>
                        </div>

                        <div className="filedinput">
                            <input type="text" placeholder="URL" value={newBannerLink} onChange={(e) => setNewBannerLink(e.target.value)} />
                        </div>

                        <div className="buttonss">
                            <button className="btn-1" onClick={handleClose1}>Cancel</button>
                            <button className="btn-1 btn-2" onClick={handleUpdateBanner}>Update Save</button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default Bannerappmanagment;
